import { useContext } from 'react';

import { UserRolesForSchoolContext } from './UserRolesForSchoolContext';

export const useUserRolesForSchool = () => {
  return useContext(UserRolesForSchoolContext);
};
